import { Component } from '@angular/core';

@Component({
  selector: 'mprd-cyber-care-cease-modal',
  templateUrl: './cyber-care-cease-modal.component.html',
  styleUrls: ['./cyber-care-cease-modal.component.css'],
})
export class CyberCareCeaseModalComponent {
  jsonProduct: string;

  constructor() {}
}
